// extracted by css-extract-rspack-plugin
export default {"breadcrumbs":"mZXF9","breadcrumb":"e8A4L"};